var _circle, _path, _path2, _path3, _path4, _circle2, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnbBusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 16,
    r: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0128 5.37811L42.6478 8.06852L36.0129 14.6838L33.3779 12.0566L40.0128 5.37811Z",
    fill: "#F0B90A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0128 9.36615L46.6478 12.0566L36.0129 22.6599L33.3779 20.0328L44.0128 9.36615Z",
    fill: "#F0B90A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0129 13.3544L34.6478 16.0448L32.0129 18.6719L29.3779 16.0448L32.0129 13.3544Z",
    fill: "#F0B90A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0128 13.3544L50.6478 16.0448L40.0129 26.6482L37.3779 24.0211L48.0128 13.3544Z",
    fill: "#F0B90A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F0B90A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8559 10.0108L11.713 14.1536L9.30244 11.743L15.8559 5.18915L22.4116 11.7451L20.001 14.1558L15.8559 10.0108ZM7.60019 13.4447L5.18945 15.8555L7.60005 18.2661L10.0108 15.8553L7.60019 13.4447ZM11.713 17.558L15.8559 21.7008L20.0009 17.556L22.4128 19.9654L22.4116 19.9666L15.8559 26.5225L9.30223 19.9689L9.29881 19.9655L11.713 17.558ZM24.1122 13.4461L21.7015 15.8568L24.1121 18.2674L26.5228 15.8567L24.1122 13.4461Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2837 15.9988H18.2847L16.0001 13.7142L14.3117 15.4025H14.3116L14.1176 15.5966L13.7175 15.9968L13.7144 15.9998L13.7175 16.0031L16.0001 18.2857L18.2847 16.0011L18.2858 15.9998L18.2837 15.9988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbBusd);
export default __webpack_public_path__ + "static/media/bnb-busd.249f310ced53227c2249659fc69fafad.svg";
export { ForwardRef as ReactComponent };